import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Home';
import MindfulBreathing from './MindfulBreathing';
import About from './About';
import MBPrivacy from './MBPrivacy';

const Main = () => (
  <main>
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/mindfulbreathing/privacy' element={<MBPrivacy/>} />
      <Route path='/mindfulbreathing' element={<MindfulBreathing/>} />
      <Route path='/about' element={<About/>} />
    </Routes>
  </main>
)

export default Main
